<user>
  <div id="memo1_after"></div>
  <div id="up">
    <ul>
      <li id="point"><span class="up-label">現在のポイント：</span><span class="up-value">{ state.point }ポイント</span></li>
      <li id="expire-date"><span class="up-label">有効期限：</span><span class="up-value">{ state.expireDate }</span></li>
    </ul>
  </div>
  <div class="note-group">
    <div id="memo2_after"></div>
  </div>
  <script>
    import dayjs from 'dayjs';
    import { convertSpwToState } from '@/point/convertSpwToState';
    export default {
      onMounted() {
        const { memo1_after, memo2_after } = convertSpwToState(this.props.web);
        const { point, expireDate } = this.props.up;
        this.state.point = point;
        this.state.expireDate = expireDate <= 0 ? 'なし' : dayjs(expireDate.toString()).format('YYYY年MM月DD日');
        this.update();
        const note1Div = document.getElementById('memo1_after');
        const note2Div = document.getElementById('memo2_after');
        note1Div.insertAdjacentHTML('afterbegin', memo1_after);
        note2Div.insertAdjacentHTML('afterbegin', memo2_after);
      },
    };
  </script>
  <style type="postcss">
    .note-group{
      margin-top: 15px;
    }

    @media (min-width: 641px) {
      #up ul {
        margin: 0;
        padding: 0;
        list-style: none;
      }

      #up li {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      #up li::before {
        content: none !important;
      }
    }

    @media (max-width: 640px) {
      #up {
        margin: 4px 0;
        padding: 0;
        border: 0;
        border-radius: 0;
        background: transparent;
        width: 100%;
        max-width: 100%;
        min-width: 0;
        overflow: hidden;
      }

      #up ul {
        display: grid;
        gap: 4px;
        margin: 0;
        padding: 0;
        list-style: none;
        width: 100%;
        max-width: 100%;
        min-width: 0;
        overflow: hidden;
      }

      #up li {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 0 4px;
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding-bottom: 8px;
        border-bottom: 1px solid #e7edf5;
        font-size: 0.7rem;
        white-space: normal;
        overflow-wrap: anywhere;
      }

      #up .up-label {
        flex: 0 0 auto;
      }

      #up .up-value {
        min-width: 0;
        overflow-wrap: anywhere;
      }

      #up li:last-child {
        padding-top: 4px;
        padding-bottom: 8px;
      }

      #up #point,
      #up #expire-date {
        font-size: 0.77rem;
      }

      #up #point {
        font-weight: 700;
      }

      .note-group{
        margin-top: 8px;
      }
    }
  </style>
</user>
